import { Injectable } from '@angular/core';
import { Collection } from '../shared';
import { ISapRegion, ISapTerritory } from '../shared/types';
import { Observable } from 'rxjs';
import { SyncApiService } from '../../shared/services/sync-api.service';
import { API_COMMON } from '../shared/enum';
import { filter, map, take, tap } from 'rxjs/operators';

const TERRITORIES_DATA = 'TERRITORIES_DATA';

@Injectable({ providedIn: 'root' })
export class SapTerritoriesService {
  public readonly sapTerritories$: Collection<ISapTerritory> = new Collection<ISapTerritory>({
    indexBy: 'code',
  });

  public getSapTerritories = (): Observable<ISapTerritory[]> => {
    const { sapTerritories$ } = this;

    if (!sapTerritories$.size && !sapTerritories$.isWaiting(TERRITORIES_DATA)) {
      sapTerritories$.setWaiting(TERRITORIES_DATA, true);

      this.api
        .get(API_COMMON.SAP_TERRITORIES)
        .pipe(
          take(1),
          map((sapTerritories: ISapTerritory[]) => {
            // ToDo: let's change it on Backend
            const CA = sapTerritories.find(t => t.code === 'CA'); // Quick fix for GLSS-2504
            const GB = sapTerritories.find(t => t.code === 'GB'); // Quick fix for GLSS-6938
            const SE = sapTerritories.find(t => t.code === 'SE'); // Quick fix for GLSS-7897

            CA && (CA.postalCodeValidationRuleNumber = 10);
            GB && Object.assign(GB, { postalCodeValidationRuleNumber: 3, postalCodeLength: 9 });
            SE && Object.assign(SE, { postalCodeValidationRuleNumber: 11, postalCodeLength: 6 });

            return sapTerritories;
          }),
          tap((sapTerritories: ISapTerritory[]) => {
            sapTerritories$.replaceAll(sapTerritories).setWaiting(TERRITORIES_DATA, false);
          })
        )
        .subscribe();
    }

    return sapTerritories$.onChange().pipe(filter(() => !!sapTerritories$.size));
  };

  public getSapTerritory = (countryCode: any): Observable<ISapTerritory> => {
    const { sapTerritories$, getSapTerritories } = this;

    return getSapTerritories().pipe(map(() => sapTerritories$.getItem(countryCode)));
  };

  public getSapRegion = (countryCode: any, regionCode: any): Observable<ISapRegion> => {
    const { getSapTerritory } = this;

    return getSapTerritory(countryCode).pipe(
      map((sapTerritory: ISapTerritory) => {
        return (sapTerritory?.sapRegions || []).find(r => r?.name === regionCode) || null;
      })
    );
  };

  constructor(public readonly api: SyncApiService) {}
}
